import {Svg, Path} from 'react-native-svg';
import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useNavigate} from 'extensions/navigation';
import {useMenu} from 'extensions/viewport/useMenu';
import {Store} from 'store/slices/files/types';
import {selectors} from 'store/slices/files';
import {vectors, colors} from 'config/styles';

import * as effects from 'interface/hooks/effects/files';

export function useMenuSort(folderKey: string) {
  const {t} = useLingui();
  const sort = useSelector(selectors.getSort);
  const filter = useSelector(selectors.getFilter);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const choose = useCallback((category: Store['sort']['category']) => {
    const order = sort.order === 'asc' ? 'desc' : 'asc';
    effects.sort(navigate, dispatch, folderKey)({category, order}, filter);
  }, [folderKey, navigate, sort, filter, dispatch]);

  const icon = useCallback((isActive: boolean) => 
    <Svg viewBox="0 0 24 24" width={22} height={22}>
      <Path
        d={sort.order === 'asc' ? vectors.icons.arrowUp : vectors.icons.arrowDown}
        fill={isActive
          ? colors.neutral.mid
          : 'transparent'}
      />
    </Svg>
  , [sort]);

  const {open, exit, reference} = useMenu(
    () => [
      {
        command: 'header',
        text: t`Sort`,
      },
      {
        command: 'name',
        icon: icon(sort.category === 'name'),
        text: t`Sort by Name`,
      },
      {
        command: 'date',
        icon: icon(sort.category === 'date'),
        text: t`Sort by Date`,
      },
      {
        command: 'size',
        icon: icon(sort.category === 'size'),
        text: t`Sort by Size`,
      },
      {
        command: 'downloads',
        icon: icon(sort.category === 'downloads'),
        text: t`Sort by Downloads`,
      },
    ],
    (command: Store['sort']['category']) => {
      choose(command);
      exit();
    },
    false,
  );

  return {open, exit, reference};
}
